import {notifyBugsnagClient} from "@pg-mono/bugsnag-client";
import {consoleError} from "@pg-mono/logger";
import {appendQueryString, getExternalRequest} from "@pg-mono/request";
import {apiBigDataLink} from "@pg-mono/rp-api-routes";

import {bigDataApiUrl} from "../../../app/read_rp_environment_variables";
import {DistrictAveragePrices} from "../types/DistrictAveragePrices";
import {DistrictAveragePricesQuery} from "../types/DistrictAveragePricesQuery";

export const fetchDistrictAveragePricesBySlug = (query: DistrictAveragePricesQuery): Promise<DistrictAveragePrices[]> => {
    const endpointLink = apiBigDataLink.monthDistrictTypeStats.base;
    const url = appendQueryString(endpointLink(bigDataApiUrl), {...query});

    return getExternalRequest({}, url, 5000).catch((err) => {
        notifyBugsnagClient(err, "fetch_district_average_prices");

        consoleError("fetchDistrictAveragePricesBySlug error: ", err);
        return [];
    });
};
import {notifyBugsnagClient} from "@pg-mono/bugsnag-client";
import {consoleError} from "@pg-mono/logger";
import {appendQueryString, getExternalRequest} from "@pg-mono/request";
import {apiBigDataLink} from "@pg-mono/rp-api-routes";

import {bigDataApiUrl} from "../../../app/read_rp_environment_variables";
import {DistrictAveragePrices} from "../types/DistrictAveragePrices";
import {DistrictAveragePricesQuery} from "../types/DistrictAveragePricesQuery";

export const fetchDistrictAveragePricesBySlug = (query: DistrictAveragePricesQuery): Promise<DistrictAveragePrices[]> => {
    const endpointLink = apiBigDataLink.monthDistrictTypeStats.base;
    const url = appendQueryString(endpointLink(bigDataApiUrl), {...query});

    return getExternalRequest({}, url, 5000).catch((err) => {
        notifyBugsnagClient(err, "fetch_district_average_prices");

        consoleError("fetchDistrictAveragePricesBySlug error: ", err);
        return [];
    });
};
